import { API_BASE_URL } from '../../../../../config';
import { FORM_CODE_FF002, type EmploymentContractFormValues } from './employmentContractTypes';

export const DONE_STEP_ID = '__done__';

export type EmploymentContractProgressPayload = {
  values: EmploymentContractFormValues;
  currentStepId: string | null;
};

function parsePayload(data: {
  documentRead?: string;
  agree?: string;
  consentDate?: string;
  currentStepId?: string | null;
}): EmploymentContractProgressPayload {
  const values: EmploymentContractFormValues = {};
  if (data.documentRead === 'yes' || data.documentRead === 'no') {
    values.documentRead = data.documentRead;
  }
  if (data.agree === 'true' || data.agree === 'false') {
    values.agree = data.agree;
  }
  if (data.consentDate?.trim()) {
    values.consentDate = data.consentDate.trim();
  }
  return {
    values,
    currentStepId: data.currentStepId ?? null,
  };
}

/** Shared consent progress API (employee_form_consent). */
export async function fetchEmploymentContractProgress(
  email: string,
  invitationId: string,
  formCode: string = FORM_CODE_FF002
): Promise<EmploymentContractProgressPayload | null> {
  if (!API_BASE_URL || !email?.trim() || !invitationId?.trim()) return null;
  const code = formCode?.trim() || FORM_CODE_FF002;
  const params = new URLSearchParams({
    email: email.trim(),
    invitationId: invitationId.trim(),
    formCode: code,
  });
  const r = await fetch(`${API_BASE_URL}/api/employee-form-consent/progress?${params.toString()}`);
  if (!r.ok) return null;
  return parsePayload((await r.json()) as Parameters<typeof parsePayload>[0]);
}

export async function upsertEmploymentContractProgress(params: {
  email: string;
  invitationId: string;
  formCode?: string;
  values: EmploymentContractFormValues;
  currentStepId: string | null;
}): Promise<EmploymentContractProgressPayload | null> {
  if (!API_BASE_URL || !params.email?.trim() || !params.invitationId?.trim()) return null;
  try {
    const body: Record<string, string | null> = {
      email: params.email.trim(),
      invitationId: params.invitationId.trim(),
      formCode: (params.formCode?.trim() || FORM_CODE_FF002).toUpperCase(),
      currentStepId: params.currentStepId,
    };
    if (params.values.documentRead) {
      body.documentRead = params.values.documentRead;
    }
    if (params.values.agree === 'true' || params.values.agree === 'false') {
      body.agree = params.values.agree;
    }
    const r = await fetch(`${API_BASE_URL}/api/employee-form-consent/progress`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!r.ok) {
      console.warn('Employee form consent save failed', r.status);
      return null;
    }
    return parsePayload((await r.json()) as Parameters<typeof parsePayload>[0]);
  } catch (e) {
    console.warn('Employee form consent save error', e);
    return null;
  }
}
